<script lang="ts">
  import { getStr } from '../../../common/util';

  export let variant: 'PLP' | 'CAROUSEL' | 'CAROUSEL_TITLE' | 'PLP_GRID' = 'PLP';
</script>

<div class="mirakl-sponsored-tag variant-{variant}">
  {getStr('extra.sponsored.text')}
</div>

<style lang="scss">
  @import '../styles/colors.new.scss';

  .mirakl-sponsored-tag {
    color: $primary-blue;
    font-size: 12px;
    font-weight: 500;

    &.variant- {
      &PLP {
        margin-bottom: 20px;
      }
      &CAROUSEL_TITLE {
        font-size: 16px;
        margin-left: auto;
      }
      &PLP_GRID {
        margin-bottom: 0;
      }
    }
  }
</style>
